import { Component } from '@angular/core';

@Component({
  selector: 'mav-cns-logo-icon',
  templateUrl: './cns-logo-icon.component.html',
  styleUrls: ['./cns-logo-icon.component.scss']
})
export class CnsLogoIconComponent {

  constructor() { }
}
